import * as React from 'react'

import ResourceMapLayout from '~/client/src/desktop/components/Resource/ResourceMapLayout'
import StruxTagMapMarker from '~/client/src/shared/components/MapMarker/StruxTagMapMarker'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import StruxTagMapPopup from './StruxTagMapPopup'

const StruxTagsMapLayout: React.FC = () => (
  <ResourceMapLayout
    icon="sensor"
    countLabel={count => Localization.translator.xStruxTags(count)}
    markerTitleFallback={Localization.translator.struxTags}
    PopupComponent={StruxTagMapPopup}
    MarkerComponent={StruxTagMapMarker}
    markerAnchor="bottom"
  />
)

export default StruxTagsMapLayout
